module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('circle-spinner', {
    class: ['erco-spinner', {
      '-fixed-color': _vm.isFixedColor
    }],
    attrs: {
      "size": this.size
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e45cd40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/ErcoSpinner.vue
// module id = 617
// module chunks = 0